<template>
	<div class="advert-manage-container">
		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<el-col :span="6">
					<el-input v-model="query.triggerSource" placeholder="请输入伙伴名称" />
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.assetCategory" placeholder="请选择伙伴类型" clearable style="width: 100%">
						<el-option label="租赁商" value="租赁商" />
						<el-option label="中介商" value="中介商" />
						<el-option label="维保商" value="维保商" />
					</el-select>
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.assetCategory" placeholder="请选择业务标签" clearable style="width: 100%">
						<el-option label="创新租赁" value="创新租赁" />
						<el-option label="委托租售" value="委托租售" />
						<el-option label="增值服务" value="增值服务" />
						<el-option label="房产经纪" value="房产经纪" />
						<el-option label="其他" value="其他" />
					</el-select>
				</el-col>
			</template>
		</QueryCard>
		<!-- 表格 -->
		<BaseTable
			:actions="{
				operation: true,
			}"
			:selection="false"
			:loading="loading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="query.pageNum"
			:pageSize="query.pageSize"
			@page-change="pageChange"
			@size-change="sizeChange">
			<template slot="toolbar">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增伙伴</el-button>
			</template>
			<template #businessTag="{ row }">
				<el-tag
					v-for="(tag, i) in row.businessTag"
					:key="i"
					:type="getRandomTagType(tag)"
					style="margin-right: 6px"
					size="small">
					{{ tag }}
				</el-tag>
			</template>
			<template #status="{ row }">
				<el-tag :type="row.status === '正常' ? 'success' : 'danger'" size="small">
					{{ row.status }}
				</el-tag>
			</template>
			<template #operation="{ row }">
				<el-button type="text" @click="handleDetail(row)">详情</el-button>
				<el-button type="text" @click="handleEdit(row)">编辑</el-button>
				<el-popconfirm title="是否删除？" icon="el-icon-info" icon-color="red">
					<el-button slot="reference" type="text" style="color: #f56c6c; margin-left: 14px" @click="handleDelete(row)">
						删除
					</el-button>
				</el-popconfirm>
			</template>
		</BaseTable>

		<PartnerManagementDialog :dialogVisible.sync="dialogVisible" :isEdit="isEdit" :data="currentRow" />
		<PartnerManagementDetailDrawer :dialogVisible.sync="drawerVisible" :data="currentRow" />
	</div>
</template>

<script>
	import PartnerManagementDialog from '@/components/operation/partnerManagementDialog.vue';
	import PartnerManagementDetailDrawer from '@/components/operation/partnerManagementDetailDrawer.vue';
	export default {
		components: {
			PartnerManagementDialog,
			PartnerManagementDetailDrawer,
		},
		data() {
			return {
				total: 3,
				query: {
					triggerSource: '',
					pageNum: 1,
					pageSize: 10,
				},
				tableData: [
					{
						index: 1,
						partnerName: '南京创新科技有限公司',
						partnerType: '租赁商',
						entityType: '公司',
						businessTag: ['创新租赁', '增值服务'],
						contactPerson: '张三',
						contactPhone: '13800138001',
						creator: 'admin',
						status: '正常',
					},
					{
						index: 2,
						partnerName: '李四军',
						partnerType: '中介商',
						entityType: '个人',
						businessTag: ['委托租售'],
						contactPerson: '李四',
						contactPhone: '13900139002',
						creator: 'admin',
						status: '正常',
					},
					{
						index: 3,
						partnerName: '南京房产经纪有限公司',
						partnerType: '中介商',
						entityType: '公司',
						businessTag: ['房产经纪'],
						contactPerson: '王五',
						contactPhone: '13700137003',
						creator: 'admin',
						status: '已终止',
					},
				],
				columns: [
					{ label: '序号', prop: 'index', width: 80, align: 'center' },
					{ label: '伙伴名称', prop: 'partnerName' },
					{ label: '伙伴类别', prop: 'partnerType' },
					{ label: '类型', prop: 'entityType' },
					{ label: '业务标签', prop: 'businessTag', slot: 'businessTag', align: 'left' },
					{ label: '联系人', prop: 'contactPerson' },
					{ label: '联系电话', prop: 'contactPhone' },
					{ label: '录入人员', prop: 'creator' },
					{ label: '合作状态', prop: 'status', slot: 'status' },
				],
				loading: false,
				currentRow: {},
				isEdit: false,
				dialogVisible: false,
				drawerVisible: false,
			};
		},
		methods: {
			getRandomTagType(str) {
				const tagTypes = ['success', 'info', 'primary'];
				let hash = 0;
				for (let i = 0; i < str.length; i++) {
					hash = str.charCodeAt(i) + ((hash << 5) - hash);
				}
				const index = Math.abs(hash) % tagTypes.length;
				return tagTypes[index];
			},
			getList() {},
			pageChange(page) {
				this.query.pageNum = page;
				this.getList();
			},
			sizeChange(size) {
				this.query.pageSize = size;
				this.getList();
			},
			handleSearch() {
				this.query.pageNum = 1;
				this.getList();
			},
			handleReset() {
				this.query = {
					triggerSource: '',
					pageNum: 1,
					pageSize: 10,
				};
				this.getList();
			},
			handleAdd() {
				this.dialogVisible = true;
				this.isEdit = false;
			},
			handleDetail(row) {
				this.currentRow = row;
				this.drawerVisible = true;
			},
			handleEdit(row) {
				this.currentRow = row;
				this.dialogVisible = true;
				this.isEdit = true;
			},
			handleDelete(row) {
				this.currentRow = row;
				this.dialogContractVisible = true;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
	}
</style>
